import { render } from "./cardPunch.vue?vue&type=template&id=2346de91&scoped=true"
import script from "./cardPunch.vue?vue&type=script&lang=js"
export * from "./cardPunch.vue?vue&type=script&lang=js"

import "./cardPunch.vue?vue&type=style&index=0&id=2346de91&scoped=true&lang=css"

import exportComponent from "E:\\web project\\web-serial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2346de91"]])

export default __exports__